<template>
  <component :is="component" :filterData="filterData" :paginationData="paginationData" v-if="component" />
</template>

<script>
export default {
  name: "PortfolioFilterLink",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    filterLayout: {},
    filterData: {
      default: () => {
      }
    },

    paginationData: {default: () => { return { total: 0, page: 0, size: 0, }}},
  },
  data() {
    return{
      component: null,
    }
  },
  beforeRouterEnter() {},
  created() {

  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
    loader() {
      if (!this.filterLayout) {
        return null
      }
      return () => import(`@/template/portfolio/filter/${this.filterLayout}`)
    },
  },
  methods:{
    filterLoader() {
      this.loader()
          .then(() => {
            this.component = () => this.loader()
          })
          .catch(() => {
            this.component = () => import('@/template/portfolio/filter/PortfolioFilterDefaultLayout')
          })
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>